<template>
    <page :title="isEditMode ? 'updateRecordTitle' : 'newRecordTitle'" :textHeight="getWindowHeight">
        <template #pageContainer>
            <form>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:label="$t('text.firstName')+'*'"
						v-model="form.athleteFirstname"
						:error-messages="errors('athleteFirstname')"
						required
						@input="$v.form.athleteFirstname.$touch()"
						@blur="$v.form.athleteFirstname.$touch()">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:label="$t('text.lastName')+'*'"
						v-model="form.athleteLastname"
						:error-messages="errors('athleteLastname')"
						required
						@input="$v.form.athleteLastname.$touch()"
						@blur="$v.form.athleteLastname.$touch()">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-autocomplete outlined dense
						hide-details="auto"
						:disabled="loading"
						clearable
						v-model="form.athleteIocCode"
						:items="athleteIocCodeSelector"
						:label="$t('text.originCountry')+'*'"
						:error-messages="errors('athleteIocCode')"
						:loading="loading"
						@input="$v.form.athleteIocCode.$touch()"
						@blur="$v.form.athleteIocCode.$touch()">
					</v-autocomplete>
				</v-col></v-row>
				<v-row><v-col>
					<v-autocomplete outlined dense
						hide-details="auto"
						:disabled="loading"
						v-model="form.gender"
						:items="genderSelector"
						:label="$t('text.genderLable')+'*'"
						:error-messages="errors('gender')"
						:loading="loading"
						@input="$v.form.gender.$touch()"
						@blur="$v.form.gender.$touch()">
					</v-autocomplete>
				</v-col></v-row>
				<v-row v-if="isAthleteEvent"><v-col>
					<v-autocomplete outlined dense
						hide-details="auto"
						:disabled="loading"
						v-model="form.yearOfBirth"
						:items="yearOfBirthSelector"
						:label="$t('text.yob')"
						:error-messages="errors('yearOfBirth')"
						:loading="loading">
					</v-autocomplete>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:label="$t('text.nationalAthleteCode')"
						v-model="form.nationalAthleteCode"
						:error-messages="errors('nationalAthleteCode')">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-autocomplete outlined dense
						hide-details="auto"
						:disabled="loading"
						v-model="form.internationalEventShort"
						:items="internationalEventShortSelector"
						:label="$t('text.event')+'*'"
						:error-messages="errors('internationalEventShort')"
						:loading="loading"
						@change="onEventChanged()"
						@input="$v.form.internationalEventShort.$touch()"
						@blur="$v.form.internationalEventShort.$touch()">
					</v-autocomplete>
				</v-col></v-row>
				<v-row><v-col>
					<v-autocomplete outlined dense
						hide-details="auto"
						:disabled="loading"
						clearable
						v-model="form.recordCountry"
						:items="athleteIocCodeSelector"
						:label="$t('text.country')+'*'"
						:error-messages="errors('recordCountry')"
						:loading="loading"
						@input="$v.form.recordCountry.$touch()"
						@blur="$v.form.recordCountry.$touch()">
					</v-autocomplete>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:label="$t('text.town')+'*'"
						v-model="form.recordTown"
						:error-messages="errors('recordTown')"
						required
						@input="$v.form.recordTown.$touch()"
						@blur="$v.form.recordTown.$touch()">
					</v-text-field>
				</v-col></v-row>
				<!-- <v-row><v-col>
					<v-autocomplete outlined dense
						hide-details="auto"
						:disabled="loading"
						clearable
						v-model="form.recordStatus"
						:items="recordState"
						:label="$t('text.recordStateLable')"
						:error-messages="errors('recordStatus')"
						:loading="loading"
						@input="$v.form.recordStatus.$touch()"
						@blur="$v.form.recordStatus.$touch()">
					</v-autocomplete>
				</v-col></v-row> -->
				<v-row><v-col>
				<v-menu
					v-model="menuStart"
					:close-on-content-click="false"
					offset-y
					max-width="290">
					<template #activator="{ on }">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							:label="$t('text.date')+'*'"
							:error-messages="errors('date')"
							required
							v-on="on"
							v-model="helper.date"
							@input="readDate"
							@blur="readDate">
						</v-text-field>
					</template>
					<v-date-picker
						locale="DE-de"
						v-model="form.date"
						@change="menuStart = false"
						@input="formatDate">
					</v-date-picker>
				</v-menu>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:disabled="form.internationalEventShort==''"
						:label="$t('text.bestResult')+'*'"
						v-model="form.formatedValue"
						:error-messages="errors('value')"
						required
						@keyup="formatValue"
						@input="$v.form.formatedValue.$touch()"
						@blur="$v.form.formatedValue.$touch()">
					</v-text-field>
				</v-col></v-row>
				<v-row v-if="isWind"><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:label="$t('text.windResult')"
						v-model="form.windSpeed"
						:error-messages="errors('windSpeed')"
						@keyup="formatWind">
					</v-text-field>
				</v-col></v-row>
				<v-row v-if="isHeightWeight"><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:label="$t('text.heightWeight')"
						v-model.number="form.heightWeight"
						:error-messages="errors('heightWeight')"
						required
						@input="$v.form.heightWeight.$touch()"
						@blur="$v.form.heightWeight.$touch()">
					</v-text-field>
				</v-col></v-row>
            </form>
            <spinner :loading="loading"></spinner>
        </template>
		<template #pageActions>
			<v-row><v-col>
				<v-btn v-if="!isEditMode"
					class="mr-4"
					:loading="loading"
					:disabled="$v.$invalid  || loading"
					@click="createAndBack">
					{{ $t(`text.createButton`) }}
				</v-btn>
				<v-btn v-else
					class="mr-4"
					:loading="loading"
					:disabled="$v.$invalid || loading"
					@click="createAndBack">
					{{ $t(`text.updateButton`) }}
				</v-btn>
				<v-btn
					class="mr-4"
					:loading="loading"
					:disabled="$v.$invalid || loading"
					@click="createAndNew">
					{{ $t(`text.createAndNew`) }}
				</v-btn>
				<v-btn
					:disabled="loading"
					class="mr-4"
					@click="back">
					{{ $t(`text.backButton`) }}
				</v-btn>
			</v-col></v-row>
		</template>
    </page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';


import Page from '../general/Page.vue';
import Spinner from '../general/Spinner.vue';

import recordsActions from '../store/actions/records';
import definitionsActions from '../store/actions/definitions';
import namespace from '../store/namespace';

import modelState from '../mixins/modelState';
import formater from '../mixins/formater';
import validationRules from '../mixins/validationRules';
import getGenderSelectorList from '../models/gender';
import getRecordState from '../models/recordState';
import getIOC from '../models/IOC';


export default {
	name: 'NewRecord',
	components: {
		Page,
		Spinner,
	},
	mixins: [modelState, formater, validationRules],
	validations: {
		form: {
			athleteFirstname: {
				required,
			},
			athleteLastname: {
				required,
			},
			athleteIocCode: {
				required,
			},
			gender: {
				required,
			},
			internationalEventShort: {
				required,
			},
			recordCountry: {
				required,
			},
			recordTown: {
				required,
			},
			recordStatus: {
				required,
			},
			heightWeight: {
				// eslint-disable-next-line func-names
				required: requiredIf(function () { return this.isHeightWeight; }),
			},
			date: {
				required,
			},
			formatedValue: {
				required,
			},
		},
	},
	data() {
		return {
			form: {
				athleteFirstname: '',
				athleteLastname: '',
				athleteIocCode: '',
				gender: 0,
				yearOfBirth: 0,
				nationalAthleteCode: '',
				worldAthleteNumber: '',
				globalCompetitorGuid: null,
				internationalEventShort: '',
				recordCountry: '',
				recordTown: '',
				recordStatus: 0,
				heightWeight: 0,
				windSpeed: 0,
				date: null,
				formatedValue: 0,
			},
			helper: {
				date: null,
			},
			recordPristine: null,
			recordSet: null,
			eventClass: null,
			menuStart: false,
			loading: false,
			id: this.$route.params.id || null,
			setId: this.$route.params.setId || null,
		};
	},
	watch: {
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.ORGANIZATION, ['Organization']),
		...mapGetters(namespace.RECORDS, ['RecordLinks', 'RecordSetLinks']),
		...mapGetters(namespace.DEFINITIONS, ['Events', 'DefinitionsLinks']),
		...mapGetters(namespace.ERROR, ['HasError']),
		getWindowHeight() {
			const errorMargin = this.HasError ? 56 : 0;
			return `${this.WindowSize.y - 276 - errorMargin}px`;
		},
		isEditMode() {
			return !!this.id;
		},
		genderSelector() {
			return getGenderSelectorList(this);
		},
		yearOfBirthSelector() {
			const y = new Date().getFullYear();
			const yob = Array.from(new Array(150), (x, index) => ({ text: y - index, value: y - index }));
			return yob;
		},
		athleteIocCodeSelector() {
			return getIOC(this);
		},
		internationalEventShortSelector() {
			return this.Events.map(x => ({ text: x.longname, value: x.shortInternational }));
		},
		recordState() {
			return getRecordState(this);
		},
		selectedEvent() {
			return this.Events.find(x => x.shortInternational === this.form.internationalEventShort);
		},
		isHeightWeight() {
			return this.eventClass?.heightWeight != null;
		},
		isAthleteEvent() {
			return this.eventClass?.isRelayEvent === false;
		},
		isWind() {
			return this.eventClass?.wind && this.recordSet?.eventEnvironment != 0;
		},
	},
	async mounted() {
		await this.loadData();
	},
	methods: {
		...mapActions(namespace.RECORDS, [
			recordsActions.GET_RECORDS_LINKS,
			recordsActions.GET_RECORDSET_LINKS,
			recordsActions.GET_RECORDBYID,
			recordsActions.GET_RECORDSETBYID,
			recordsActions.ADD_RECORD,
			recordsActions.UPDATE_RECORD,
		]),
		...mapActions(namespace.DEFINITIONS, [
			definitionsActions.GET_EVENTS_BY_NSHORT,
			definitionsActions.GET_DEFINITIONS_LINKS,
			definitionsActions.FETCH_IEVENT_NCLASS_BY_SHORT,
		]),
		async loadData() {
			this.loadData = true;
			try {
				if (!this.RecordLinks.length) {
					await this.GET_RECORDS_LINKS();
				}
				if (!this.RecordSetLinks.length) {
					await this.GET_RECORDSET_LINKS();
				}
				if (this.isEditMode) {
					await this.getRecordById();
				}
				this.recordSet = await this.GET_RECORDSETBYID(this.setId);
				this.form.gender = this.recordSet?.gender;
				if (!this.DefinitionsLinks.length) {
					await this.GET_DEFINITIONS_LINKS();
				}
				if (this.isEditMode) {
					await this.getEventClass();
				}
				await this.GET_EVENTS_BY_NSHORT(this.recordSet.nationalClassShort);
				this.formatValue();
			} catch (ex) {
				console.log(ex);
			}

			this.loading = false;
		},
		async onEventChanged() {
			this.resetForm();
			await this.getEventClass();
		},
		async getEventClass() {
			try {
				this.eventClass = await this.FETCH_IEVENT_NCLASS_BY_SHORT({ iEventCode: this.form.internationalEventShort, nClassCode: this.recordSet.nationalClassShort });
				if (this.isHeightWeight) {
					this.form.heightWeight = this.eventClass.heightWeight;
				}
			} catch (ex) {
				console.log(ex);
			}
		},
		async createAndBack() {
			await this.create();
			this.$router.push({
				name: 'records',
				params: {
					id: this.setId,
				},
			});
		},
		async createAndNew() {
			await this.create();
			this.resetForm();
			this.resetAthlet();
		},
		async create() {
			this.loading = true;
			this.$v.$touch();

			if (!this.$v.$invalid) {
				try {
					this.modelState = {};
					this.formatDTO();
					if (this.isEditMode) {
						await this.UPDATE_RECORD({ record: this.form, id: this.id });
					} else {
						await this.ADD_RECORD({ record: this.form, setId: this.setId });
					}
				} catch (e) {
					if (e.response.status === 422) {
						this.modelState = e.response.data;
						if (this.modelError()) {
							throw new Error(this.modelError());
						}
					}

					throw e;
				} finally {
					this.loading = false;
				}
			}
			this.loading = false;
		},
		async getRecordById() {
			this.loading = true;
			try {
				this.recordPristine = await this.GET_RECORDBYID(this.id);

				if (this.recordPristine) {
					this.form = this.recordPristine;
					// eslint-disable-next-line prefer-destructuring
					this.form.date = this.recordPristine.date.split('T')[0];
					this.formatDate();
					this.setId = this.recordPristine.recordSetId;
				}
			} finally {
				this.loading = false;
			}
		},
		back() {
			this.$router.push({
				name: 'records',
				params: {
					id: this.setId,
				},
			});
		},
		resetForm() {
			this.form.formatedValue = 0;
			this.form.windSpeed = 0;
			this.form.heightWeight = 0;
		},
		resetAthlet() {
			this.form.athleteFirstname = '';
			this.form.athleteLastname = '';
			this.form.athleteIocCode = '';
		},
		formatValue() {
			this.form.formatedValue = this.gFormatbestResult(this.form.formatedValue, this.selectedEvent?.measurement);
		},
		formatDTO() {
			if (!this.isWind) this.form.windSpeed = null;
		},
		formatDate() {
			this.helper.date = this.gFormatDate(this.form.date);
		},
		formatWind() {
			this.form.windSpeed = this.gFormatWind(this.form.windSpeed);
		},
		readDate() {
			const m = this.$moment(this.helper.date, 'DD.MM.YYYY', true);
			this.form.date = m.isValid() ? m.format('YYYY-MM-DD') : null;
		},
		errors(name) {
			const errors = [];
			const apiErrors = this.validateProperty(name);
			if (apiErrors.length > 0) {
				errors.push(apiErrors);
			}

			return errors;
		},
	},
};
</script>
